import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import ProfilePickerModal from './ProfilePickerModal'

const ProfilePicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiPriceTag3Line'}
        label={label || 'Perfil'}
        value={compactString(value, { t: t, tField: 'profileIds' })}
        onClick={() => setOpen(true)}
      />
      <ProfilePickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default ProfilePicker
